module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/area_sola-af7a6ec8240ed4a869ab64b1ce921827.jpg";